import { render, staticRenderFns } from "./ShowArticle.vue?vue&type=template&id=f75ed90c&scoped=true&"
import script from "./ShowArticle.vue?vue&type=script&lang=js&"
export * from "./ShowArticle.vue?vue&type=script&lang=js&"
import style0 from "./ShowArticle.vue?vue&type=style&index=0&id=f75ed90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75ed90c",
  null
  
)

export default component.exports